import { Box, Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { hasPermission } from 'store'
import 'utils/global.scss'

export const tabConfig = [
  { index: 0, label: 'Mentees',    path: 'mentees',    permission: ['mentorship.mentor', 'mentorship.admin'] },
  { index: 1, label: 'Enrollment', path: 'enrollment', permission: ['mentorship.admin'] },
]

export default function MentorshipTabs() {
  const { t } = useTranslation()
  const theme = useSelector(state => state.session.appearance)
  const { '*': tabName } = useParams()

  const permittedTabs = tabConfig.filter(tab => tab.permission.some(p => hasPermission(p)))

  const getTabIndex = path => {
    const [name] = path.split('/')
    const found = permittedTabs.find(tab => tab.path === name)
    return found ? found.index : permittedTabs[0]?.index ?? 0
  }

  const tabIndex = getTabIndex(tabName || '')
  const basePath = '/mentorship/management'

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
      <Tabs value={tabIndex}>
        {permittedTabs.map(tab => (
          <Tab
            key={tab.path}
            sx={{ color: tabIndex === tab.index && 'primary !important' }}
            className={tabIndex === tab.index ? 'tab-item-selected' : `tab-item-${theme}`}
            label={t(tab.label)}
            value={tab.index}
            component={Link}
            to={`${basePath}/${tab.path}`}
          />
        ))}
      </Tabs>
    </Box>
  )
}
